import React, { useState } from 'react'
import { apiMesAJsMonth, MONTHS_ES } from './Mes';
import { EVENT_COLORS } from './EventColors';
import { ESTATUS_CONFIG } from './EstatusConfigInventario';
import SettingsIcon from '@mui/icons-material/Settings';
import ModalOptions from './modalOptions';
import ModalOptionsWithSub from './ModalOptionsWithSub';


const ListadoInventarios = ({ data, getOpciones, estatus = "N", onReporteJustificacionesAuditor }) => {

    const [openOptionsFolio, setOpenOptionsFolio] = useState(null);

    const colorPorSucursal = (idsucursal) =>
        EVENT_COLORS[idsucursal % EVENT_COLORS.length];




    return (
        <div className="pa-list-view scroll">

            {/* ── Header de columnas ── */}
            <div className="pa-list-header">
                <div className="pa-list-header__fecha">Fecha</div>
                {/* <div className="pa-list-header__dot" />          */}
                <div className="pa-list-header__info borde-izq">Sucursal / Folio</div>
                <div className="pa-list-header__auditor borde-izq">Auditor principal</div>
                <div className="pa-list-header__estatus borde-izq">estatus</div>
                <div className="pa-list-header__metric borde-izq">Diferencias</div>
                <div className="pa-list-header__metric borde-izq">Justificadas</div>
                <div className="pa-list-header__metric borde-izq">Avance</div>
                <div className="pa-list-header__actions" />      {/* spacer del engranaje */}
            </div>

            {data.length === 0 ? (
                <div className="pa-list-empty">
                    Sin inventarios programados.
                </div>
            ) : (
                data.map((ev, idx) => {
                    const c = colorPorSucursal(ev.idsucursal);
                    return (
                        <div
                            key={`${ev.folio}-${idx}`}
                            className="pa-list-row"
                        // style={{ borderLeftColor: c.bg }}
                        >
                            {/* Fecha */}
                            <div className="pa-list-row__date">
                                <span className="pa-list-row__day">{String(ev.dia).padStart(2, "0")}</span>
                                <span className="pa-list-row__month">{MONTHS_ES[apiMesAJsMonth(ev.mes)].slice(0, 3)}</span>
                            </div>

                            {/* Dot color sucursal */}
                            {/* <div className="pa-list-row__dot" style={{ background: c.bg }} /> */}

                            {/* Sucursal / Folio */}
                            <div className="pa-list-row__info">
                                <span className="pa-list-row__id">{ev.sucursal} | {ev.folio}</span>
                                <span className="pa-list-row__tipo">{ev.fecha_inicio} - {ev.fecha_fin}</span>
                            </div>

                            {/* Auditor */}
                            <div className="pa-list-row__auditor">
                                <div className="pa-list-row__avatar-wrap">
                                    <div
                                        className="pa-list-row__avatar"
                                        style={{ background: c.bg }}
                                        title={ev.auditor_ppal}
                                    >
                                        {ev.auditor_ppal?.split(" ").slice(0, 2).map(w => w[0]).join("").toUpperCase()}
                                    </div>
                                    <span className="pa-list-row__auditor-name">{ev.auditor_ppal}</span>
                                </div>
                            </div>

                            {/* estatus */}
                            <div className="pa-list-row__estatus">
                                {(() => {
                                    const cfg = ESTATUS_CONFIG[ev.estatus] ?? ESTATUS_CONFIG["N"];
                                    return (
                                        <span
                                            className="pa-estatus-badge"
                                            style={{ background: cfg.bg, color: cfg.text, borderColor: cfg.border }}
                                        >
                                            <span className="pa-estatus-badge__dot" style={{ background: cfg.dot }} />
                                            {cfg.label}
                                        </span>
                                    );
                                })()}
                            </div>

                            {/* Diferencias */}
                            <div className="pa-list-row__metric">
                                <span className={`pa-metric-badge pa-metric-badge--${ev.diferencias !== 0 ? "warn" : "ok"}`}>
                                    {ev.diferencias}
                                </span>
                            </div>


                            {/* Justicicadas */}
                            <div className="pa-list-row__metric">
                                <span style={{ cursor: 'pointer' }} className={`pa-metric-badge pa-metric-badge--${ev.diferencias !== 0 ? "ok" : "ok"}`} onClick={() => onReporteJustificacionesAuditor(ev.folio)}>
                                    {ev.justificadas}
                                </span>
                            </div>

                            {/* Confiabilidad */}
                            {/* <div className="pa-list-row__metric">
                                            <div className="pa-metric-bar-wrap">
                                                <div className="pa-metric-bar">
                                                    <div
                                                        className={`pa-metric-bar__fill pa-metric-bar__fill--${ev.confiabilidad >= 90 ? "ok" : ev.confiabilidad >= 70 ? "warn" : "danger"}`}
                                                        style={{ width: `${Math.min(ev.confiabilidad, 100)}%` }}
                                                    />
                                                </div>
                                                <span className="pa-metric-bar__label">{ev.confiabilidad} %</span>
                                            </div>
                                        </div> */}

                            {/* Avance */}
                            <div className="pa-list-row__metric">
                                <div className="pa-metric-bar-wrap">
                                    <div className="pa-metric-bar">
                                        <div
                                            className="pa-metric-bar__fill pa-metric-bar__fill--blue"
                                            style={{ width: `${Math.min(ev.avance, 100)}%` }}
                                        />
                                    </div>
                                    <span className="pa-metric-bar__label">{ev.avance.toFixed(2)} %</span>
                                </div>
                            </div>

                            {/* Opciones */}
                            <div className="pa-list-settings-wrap">
                                <span
                                    className="pa-settings-icon"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenOptionsFolio(openOptionsFolio === ev.folio ? null : ev.folio);
                                    }}
                                >
                                    <SettingsIcon />
                                </span>
                                {openOptionsFolio === ev.folio && (
                                    ev.estatus === "F" ? (
                                        <div onClick={(e) => e.stopPropagation()}>
                                            <ModalOptionsWithSub
                                                onClose={() => setOpenOptionsFolio(null)}
                                                options={getOpciones(ev)}
                                            />
                                        </div>
                                    ) : (
                                        <div onClick={(e) => e.stopPropagation()}>  {/* ← evita que el click suba al pa-event */}
                                            < ModalOptions
                                                onClose={() => setOpenOptionsFolio(null)}
                                                options={getOpciones(ev)}
                                            />
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    );
                })
            )}
        </div>
    )
}

export default ListadoInventarios
